
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"fill-current",attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.65 4.85a.5.5 0 010-.7L3.83.96a.5.5 0 11.7.71L2.22 4H9v1H2.2l2.34 2.33a.5.5 0 01-.71.7L.65 4.86z","fill":"#000"}})])
          )
        }
      }
    